import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import { monFetch } from "../inc/inc";
import DeleteIcon from "@mui/icons-material/Delete";
import PopupElimina from "../elementi/PopupElimina";
import { useState, useEffect } from "react";

const Comp = (props) => {

  const [utenti, setUtenti] = useState([]);

  const [popupElimina, setPopupElimina] = useState(false);
  const [utenteDaEliminare, setUtenteDaEliminare] = useState(null);

  async function query() {
    console.log("QUERY");
    const res = await monFetch("/userList", {});
    // console.log(res);
    setUtenti(res.users);
  }

  async function eliminaUtente(id) {
    const res = await monFetch("/userDelete", { id });
    // console.log(res);
    setPopupElimina(false);
    query();
  }

  useEffect(() => {
    props.setTestoTitolo(
      <>
        <Button
          variant="contained"
          href={process.env.PUBLIC_URL + "/utente-nuovo"}
          className="buttonSalva"
          style={{ marginRight: 20 }}
        >
          Nuovo{" "}
        </Button>
        Lista Utenti
      </>
    );
    query();
  }, []);

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            {/* <TableCell>Azienda</TableCell> */}
            <TableCell>Nome</TableCell>
            <TableCell>Cognome</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Livello</TableCell>
            <TableCell>Attivo</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {utenti.map((utente) => {
            return (
              <TableRow
                key={utente.id}
                className="rigaSelezionabile"
                onClick={(e) => {
                  window.location.href = process.env.PUBLIC_URL + "/utente/" + utente.id;
                }}
              >
                {/* <TableCell>{utente.company_name}</TableCell> */}
                <TableCell>{utente.first_name}</TableCell>
                <TableCell>{utente.last_name}</TableCell>
                <TableCell>{utente.email}</TableCell>
                <TableCell>{utente.adminLevel}</TableCell>
                <TableCell>{utente.enabled ? "SI" : "NO"}</TableCell>
                <TableCell>
                  <DeleteIcon
                    color="error"
                    onClick={(e) => {
                      e.stopPropagation();
                      setPopupElimina(true);
                      setUtenteDaEliminare(utente.id);
                    }}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <PopupElimina
        open={popupElimina}
        fnAnnulla={(e) => setPopupElimina(false)}
        fnSuccess={(e) => eliminaUtente(utenteDaEliminare)}
      />
    </>
  );
};

export default Comp;
